import { Group, Progress, Stack, Text } from '@mantine/core'
import type { TeamSummaryData, WidgetDefinition, WidgetPayload } from '../api/types'

const STATUS_COLOURS: Record<string, string> = {
  active: 'teal',
  invited: 'blue',
  suspended: 'gray',
}

export function TeamSummaryWidget({
  payload,
}: {
  definition: WidgetDefinition
  payload: WidgetPayload<TeamSummaryData>
}) {
  const { total, by_status: byStatus } = payload.data
  const withPeople = byStatus.filter((status) => status.count > 0)

  return (
    <Stack gap="sm" h="100%" justify="space-between">
      <Group align="baseline" gap={6}>
        <Text fz={34} fw={600} lh={1}>
          {total}
        </Text>
        <Text size="sm" c="dimmed">
          {total === 1 ? 'person' : 'people'}
        </Text>
      </Group>

      {total > 0 && (
        <Progress.Root size="lg">
          {withPeople.map((status) => (
            <Progress.Section
              key={status.status}
              value={(status.count / total) * 100}
              color={STATUS_COLOURS[status.status] ?? 'gray'}
            >
              {/* Only labelled when the segment is wide enough to read. */}
              {status.count / total > 0.15 && <Progress.Label>{status.count}</Progress.Label>}
            </Progress.Section>
          ))}
        </Progress.Root>
      )}

      <Group gap="md" wrap="wrap">
        {byStatus.map((status) => (
          <Group key={status.status} gap={6} wrap="nowrap">
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: `var(--mantine-color-${STATUS_COLOURS[status.status] ?? 'gray'}-6)`,
              }}
            />
            <Text size="xs" c="dimmed">
              {status.label} {status.count}
            </Text>
          </Group>
        ))}
      </Group>
    </Stack>
  )
}
